import React from 'react';
import './TextAboutAdress.css';

import { Link } from 'react-router-dom';

import svgLocation from '../Img/icon/location.svg';
import svgMail from '../Img/icon/mail.svg';
import svgViber from '../Img/icon/viber.svg';
import svgArrowR from '../Img/icon/arrow-r.svg';
import svgSign from '../Img/icon/sign.svg';

const TextAboutAdress = (props) => {
  return (
		<div className="about-adress">
      <section className="s-about">
        <h3>Ми гарантуємо:</h3>
        <div className="about-text">
          <img src={svgArrowR} alt=""/> 
          <div>
          оперативне і якісне виконання доручень; 
          </div>
          <img src={svgArrowR} alt=""/> 
          <div> лояльні ціни і зручні способи розрахунків;</div>
          <img src={svgArrowR} alt=""/> 
          <div> індивідуальний підхід. За домовленістю ми можемо зустрітися з вами в зручні для вас час місці. </div>
          <img src={ svgSign } alt=""/> 
                  </div>
        <Link to='/prise'>Прайс...</Link>
      </section>
      <section className="s-adress">
        {/* <img src={svgLocation} alt=""/> Київ, проспект Берестейський, 89А <br/> */}
        {/* <img src={  svgMail  } alt=""/> consultingur@gmail.com */}
        <div className="telefon"> <a href="tel:+380502244324">(050) 224-43-24 <img src={svgViber} alt=""/></a> <br/>
                                  <a href="tel:+380672244324">(067) 224-43-24</a> <br/>
                                  <a href="tel:+380635312136">(063) 531-21-36</a><br/>
                                  <img src={  svgMail  } alt=""/> <a href="mailto:consultingur@gmail.com">consultingur@gmail.com</a>
        </div>
        <Link to='/contact' className="contact">Контакти...</Link>
      </section>
    </div>
	);
}

export default TextAboutAdress;


// WEBPACK FOOTER //
// ./src/Components/TextAboutAdress.jsx